import * as Yup from 'yup';

import { messages } from './format-template.messages';

const playerCount = Yup.number()
  .transform((value, original) => (original === '' ? undefined : value))
  .typeError(messages.errNumberInvalid.defaultMessage)
  .integer(messages.errWholeNumbers.defaultMessage)
  .min(0, messages.errNotNegative.defaultMessage);

// Shared yup shape for the create/edit template metadata block. Spread into each modal's schema so
// name / age-group / player-count rules stay identical across create and edit.
export const metadataValidationShape = {
  name: Yup.string().trim().required(messages.errNameRequired.defaultMessage),
  ageGroupBuckets: Yup.array().of(Yup.string()),
  minPlayers: playerCount,
  maxPlayers: playerCount.test(
    'max-gte-min',
    messages.errMaxGteMin.defaultMessage,
    function testMax(value) {
      const { minPlayers } = this.parent;
      if (value == null || minPlayers === '' || minPlayers == null) return true;
      return value >= Number(minPlayers);
    },
  ),
};
